
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"37","fill":"none","viewBox":"0 0 60 37"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"currentColor","d":"M57.3 37H2.5C1.1 37 0 35.9 0 34.6V2.4C0 1.1 1.1 0 2.5 0h54.7c1.4 0 2.5 1 2.6 2.4v32.2c0 1.3-1.1 2.4-2.5 2.4zM2.5 1C1.7 1 1 1.7 1 2.4v32.2c0 .8.6 1.4 1.5 1.4h54.8c.8 0 1.5-.7 1.5-1.4V2.4c-.1-.8-.7-1.4-1.6-1.4H2.5z"}}),_c('path',{attrs:{"fill":"currentColor","d":"M40.4 16.5c.7-.2 1.4-.2 2 .2.5.3.9.7 1.1 1.3.1.4.1.7.1 1-.4-.3-.9-.4-1.4-.5-.9-.1-1.8-.1-2.7.1-.9.2-1.7.7-2.2 1.5-.4.7-.4 1.4-.3 2.2.2.8.8 1.6 1.6 2 .8.4 1.7.5 2.6.4.9-.2 1.7-.7 2.2-1.4.1-.1.1-.2.2-.2v1.3h1.7v-5c0-.6 0-1.3-.3-1.8-.1-.8-.6-1.5-1.3-2-.7-.6-1.7-.8-2.7-.8-.6 0-1.4.1-2 .4-.7.3-1.3.8-1.8 1.5.6.3 1.1.7 1.6 1 .3-.6.9-1.1 1.6-1.2zm2.3 5.8c-.5.6-1.4 1-2.2.9-.6 0-1.1-.3-1.5-.7-.3-.4-.4-1-.2-1.5.2-.4.5-.7.9-.9.7-.4 1.5-.4 2.1-.3.6 0 1.2.2 1.7.6 0 .7-.3 1.4-.8 1.9zm4.6 6.3h1.9c1.9-4.5 3.9-9.1 5.9-13.6-.7 0-1.3 0-2.1-.1-.8 2.1-1.7 4.3-2.6 6.5 0 .1-.1.2-.1.3-.9-2.3-1.9-4.5-2.8-6.8h-1.9c1.3 3 2.6 5.9 3.9 8.9-.7 1.6-1.4 3.2-2.2 4.8zm-17.5-9.7h2.1c.6 0 1.2 0 1.8-.1 1-.2 1.9-.9 2.5-1.7.6-.6.8-1.5.8-2.3 0-.8-.2-1.6-.7-2.3-.6-.8-1.5-1.5-2.6-1.7-.6-.1-1.1-.1-1.7-.1h-4v13.8h1.8v-5.6zm-.1-6.6h3.1c1.2.1 2.3 1.1 2.4 2.3.1.6-.2 1.2-.6 1.7-.5.5-1.1.8-1.8.8h-3.1v-4.8zM11.1 24.5c1.2.6 2.5.9 3.8.9 1.9 0 3.8-.6 5.2-1.9 1.2-1.1 1.9-2.5 2.2-4 .3-1.1.3-2.3.1-3.4h-7.5v3.1h4.3c-.2 1-.8 1.9-1.6 2.4-.8.6-1.8.8-2.7.8-1 0-1.9-.3-2.7-.9-.8-.6-1.5-1.4-1.8-2.4-.3-1-.3-2.1 0-3.1.3-1.1 1.1-2 2-2.6.9-.6 2.1-.8 3.2-.6.9.1 1.7.5 2.3 1.1l2.3-2.3c-1.2-1.1-2.6-1.8-4.2-2-1.5-.2-3 0-4.4.6-1.7.7-3.1 2.1-3.9 3.7-.5.9-.7 2-.8 3.1v.9c0 1.1.3 2.1.8 3.1.7 1.5 1.9 2.7 3.4 3.5z"}})])
          )
        }
      }
    